import theme from "../../theme";
import type { FooterStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<FooterStyles, SxProps<Theme>> => {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      bottom: 0,
      width: "100%",
      textAlign: "center",
      zIndex: 2,
      height: "75px",
      marginTop: 20,
    },

    footer: {
      py: 3,
      mt: "auto",
      bgcolor: theme.palette.grey[200],
    },
  };
};

export default getStyles;
